module.exports = __webpack_public_path__ + "img/pos_approval.f099f5f8.png";